/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function (Tc, $, doT) {
	'use strict';

	var deparam = require('lib/vendor/jquery-deparam-patched').default;

	function getNumberOfItemsInBasket() {
		// Read number of basket items from cookie and add it to shopping basket link
		var shoppingCartQuery = ($.cookie || $.noop)('SCSMiniShoppingCart') || '';
		// Use deparam if available
		shoppingCartQuery = deparam(shoppingCartQuery);
		// Get number of items in basket or 0 and display in indicator
		return (shoppingCartQuery && shoppingCartQuery.qty) || 0;
	}

	/**
	 * Basket module implementation.
	 *
	 * @author
	 * @namespace Tc.Module
	 * @class Basket
	 * @extends Tc.Module
	 */
	Tc.Module.Basket = Tc.Module.extend({

		on: function (callback) {
			var mod = this;
			mod.groupTpl = doT.template(mod.$ctx.find('.scsh-tmpl-basket-group').html());
			mod.itemTpl = doT.template(mod.$ctx.find('.scsh-tmpl-basket-item-group').html());

			mod.updateBasketNumberIndicator();
			mod.initShoppingCartMini();

			callback();
		},

		initShoppingCartMini: function () {
			var mod = this,
				$ctx = mod.$ctx;

			var url = $ctx.find('.scsh-basket-cartmini').data('url');

			$ctx.find('.scsh-header-icon').click(function () {

				// todo just get the closes with position : relative
				var rightDisp = ($('.scsh-icon-menu li:visible:last').offset().left + $('.scsh-icon-menu li:visible:last').width()) - $('.modBasket').offset().left - $ctx.width() / 2;
				$ctx.find('.scsh-flyout-panel').css('right', '-' + rightDisp + 'px');

				$ctx.trigger('scsh-flyout-open');

				// Write the resume shopping link cookie on Shopping cart link click (FR 14608)
				$.cookie('SCSResumeShoppingLink', window.location.href, {
					'path': '/'
				});

				mod.updateBasketNumberIndicator();
				$ctx.find('.scsh-basket-cartmini>div').hide();
				$ctx.find('.scs-loadingRotator').show();

				$.ajax({
					type: 'GET',
					url: url,
					dataType: 'json',
					success: function (json) {
						var i;

						if (json && json.BasketItems && json.BasketItems.length) {
							$('.scsh-basket-total .onetimecharge').html(json.OneTimeChargeFormatted);
							$('.scsh-basket-total .recurringcharge').html(json.RecurringChargeFormatted);
							$('.scsh-basket-cartmini-inner .scsh-basket-content').html('');

							// cart items
							for (i = 0; i < json.BasketItems.length; i += 1) {
								var groupItems = (json.BasketItems[i].ChildrenItems) ? json.BasketItems[i].ChildrenItems.length + 1 : 1;
								var itemHtml = '';
								for (var j = 0; j < groupItems; j += 1) {

									itemHtml += mod.itemTpl({
										basketItem: (j === 0) ? json.BasketItems[i] : json.BasketItems[i].ChildrenItems[j - 1],
										isFirst: j === 0
									});

								}
								$('.scsh-basket-cartmini-inner .scsh-basket-content').append(mod.groupTpl({
									inner: itemHtml
								}));
							}
							$ctx.find('.scsh-basket-cartmini-inner').show();
						} else {
							// empty cart
							$ctx.find('.scsh-basket-cartmini-empty').show();
							$ctx.find('.scsh-header-icon sup').remove();
						}
						$ctx.find('.scs-loadingRotator').hide();
					},
					error: function (error) {
						// If empty response (JSON parse error)
						if (error.status === 200) {
							$ctx.find('.scsh-basket-cartmini-empty').show();
							$ctx.find('.scsh-header-icon sup').remove();
							$ctx.find('.scs-loadingRotator').hide();
						}
					}
				});

			});

		},

		// Refactor warning: this may be called from the outside.
		updateBasketNumberIndicator: function () {
			var $ctx = this.$ctx;
			var basketItems = getNumberOfItemsInBasket();
			$ctx.find('.scsh-header-icon sup').attr('data-item-count', basketItems);
		}
	});

	// Export for others to use
	Tc.Module.Basket.getNumberOfItemsInBasket = getNumberOfItemsInBasket;

}(window.Tc, window.scsHeaderJQuery, window.doT));

}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/header/clientlibs/responsive/js/modules/Tc.Module.Basket.js
// module id = 359
// module chunks = 0